import React, { useEffect, useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { config } from "../../style";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const CustomAccordion = ({ summary, details, defaultExpanded, view = "", gutterBottom = false }) => {
    if (view === "v1") {
        return (
            <Accordion
                disableGutters
                sx={{
                    borderRadius: "10px",
                    border: "1px solid  #E9E9E9",
                    color: config.baseColor,

                    "&::before": {
                        display: "none",
                    },

                    marginBottom: gutterBottom ? "1rem" : "0rem",
                    "&:last-child": {
                        marginBottom: gutterBottom ? "0" : "0rem",
                    },
                    
                }}
                defaultExpanded={defaultExpanded}
            >
                <AccordionSummary
                    expandIcon={<KeyboardArrowRightIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                        "& .MuiAccordionSummary-content": {
                            color: "brand.main",
                            marginLeft: "8px",
                        },
                        "& .MuiAccordionSummary-expandIconWrapper": {
                            color: "brand.main",
                        },

                        "&.MuiAccordionSummary-root": {
                            flexDirection: "row-reverse",
                        },

                        [`& .MuiAccordionSummary-expandIconWrapper.Mui-expanded`]: {
                            transform: "rotate(90deg)",
                        },
                    }}
                >
                    {summary}
                </AccordionSummary>
                <AccordionDetails>{details}</AccordionDetails>
            </Accordion>
        );
    } else {
        return (
            <Accordion
                sx={{
                    width: "100%",
                    bgcolor: "white",
                    borderRadius: 2,
                    m: 0,
                    p: 0,
                    background: "#f8f8f8",
                    "& .MuiAccordionSummary-content": {
                        m: 0,
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                        m: 0,
                    },
                    "& .MuiAccordionSummary-root.Mui-expanded": {
                        minHeight: "48px",
                    },
                    "& .MuiAccordionDetails-root": {
                        background: "white",
                    },
                }}
                defaultExpanded={defaultExpanded}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ m: 0 }} aria-controls="panel1-content" id="panel1-header">
                    {summary}
                </AccordionSummary>
                <AccordionDetails>{details}</AccordionDetails>
            </Accordion>
        );
    }
};

export { CustomAccordion };
